module.exports = __webpack_public_path__ + "static/knittedgreystripe-d2212f2f101ef639f05179b91d585418.jpeg";